import { CountryCode, ROUTES } from "@nf/constants";
import { GetServerSideProps } from "next";

import CookiePolicyScreen from "screens/CookiePolicyScreen";

export const getServerSideProps: GetServerSideProps = async (ctx) => {
  const { getCommonServerSideProps } = await import(
    "helpers/getCommonServerSideProps"
  );

  const { commonProps } = await getCommonServerSideProps(ctx);

  if (commonProps.country.toLowerCase() !== CountryCode.Finnish.toLowerCase()) {
    return {
      redirect: {
        destination: `/${commonProps.country}/${commonProps.language}${ROUTES.PAGE_NOT_FOUND}`,
        permanent: false,
      },
    };
  }

  return {
    props: commonProps,
  };
};

export default CookiePolicyScreen;
